module.exports = __webpack_public_path__ + "img/img_tag_promo.11758b24.svg";